import React from 'react';
import PropTypes from 'prop-types';
import css from './styles.scss';

const ActionsWrapper = ({ children }) => (
  <div className={css.ActionsWrapper}>{children}</div>
);

ActionsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionsWrapper;
